// eslint-disable-next-line import/prefer-default-export
export const companyGetters = {
    company(state) {
        return state.company
    }
};
